.headerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.filterRow {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.filterSelect {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d3d3d3;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  min-width: 220px;
  background-color: white;
  cursor: pointer;
}

.filterTextInput {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d3d3d3;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  min-width: 220px;
  background-color: white;
}

.filterTextInput:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
}

.filterDropdown {
  position: relative;
  min-width: 220px;
}

.filterDropdownSummary {
  list-style: none;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d3d3d3;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  background-color: #ffffff;
  cursor: pointer;
  user-select: none;
}

.filterDropdownSummary::-webkit-details-marker {
  display: none;
}

.filterDropdownSummary::after {
  content: '\25BE';
  float: right;
  color: #6b7280;
  font-size: 0.72rem;
  margin-top: 0.2rem;
}

.filterDropdown[open] .filterDropdownSummary {
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
}

.filterDropdownPanel {
  position: absolute;
  top: calc(100% + 0.2rem);
  left: 0;
  z-index: 5;
  width: 100%;
  min-width: 220px;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #d3d3d3;
  border-radius: 0.375rem;
  background-color: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
  padding: 0.45rem 0.5rem;
  display: grid;
  gap: 0.32rem;
}

.filterDropdownSearch {
  padding: 0.35rem 0.5rem;
  border: 1px solid #d3d3d3;
  border-radius: 0.3rem;
  font-size: 0.84rem;
}

.filterDropdownSearch:focus {
  outline: none;
  border-color: #0066cc;
}

.filterDropdownOption {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.84rem;
  color: #111827;
  cursor: pointer;
  padding: 0.1rem 0;
}

.filterDropdownNoOptions {
  margin: 0.2rem 0;
  font-size: 0.82rem;
  color: #6b7280;
}

.filterSelect:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
}

.dateFilterGroup {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.dateFilterLabel {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.78rem;
  color: #4b5563;
}

.dateFilterInput {
  padding: 0.45rem 0.55rem;
  border: 1px solid #d3d3d3;
  border-radius: 0.375rem;
  font-size: 0.92rem;
  min-width: 145px;
  background-color: white;
}

.dateFilterInput:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
}

.tableWrapper {
  overflow-x: auto;
}

.heuristicNote {
  margin: 0 0 0.75rem;
  color: #5c6570;
  font-size: 0.92rem;
}

.metricsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.75rem;
  margin: 0 0 0.9rem;
}

.metricCard {
  border: 1px solid #d3dbe3;
  border-radius: 0.5rem;
  padding: 0.75rem 0.9rem;
  background-color: #f8fafc;
}

.metricTitle {
  margin: 0;
  font-size: 0.85rem;
  color: #4b5563;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.metricRatio {
  margin: 0.4rem 0 0.25rem;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
}

.metricPositive {
  color: #1f8a3b;
}

.metricNegative {
  color: #c0392b;
}

.metricHint {
  margin: 0;
  font-size: 0.82rem;
  color: #5c6570;
}

.usageSection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  gap: 0.75rem;
  margin: 0 0 0.9rem;
}

.usageCard {
  border: 1px solid #d3dbe3;
  border-radius: 0.5rem;
  padding: 0.8rem 0.9rem;
  background-color: #ffffff;
}

.usageCard h3 {
  margin: 0 0 0.65rem;
  font-size: 0.95rem;
  color: #1f2937;
}

.funnelList,
.trendList {
  display: grid;
  gap: 0.45rem;
}

.funnelItemMeta {
  display: flex;
  justify-content: space-between;
  font-size: 0.84rem;
  color: #374151;
}

.funnelBarTrack,
.trendBarTrack {
  width: 100%;
  height: 0.5rem;
  border-radius: 999px;
  background-color: #e5e7eb;
  overflow: hidden;
}

.funnelBarFill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #60a5fa 0%, #2563eb 100%);
}

.trendItem {
  display: grid;
  grid-template-columns: 3.2rem 1fr 2.4rem;
  align-items: center;
  gap: 0.5rem;
}

.trendBarFill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #34d399 0%, #059669 100%);
}

.trendLabel,
.trendValue {
  font-size: 0.82rem;
  color: #374151;
}

.trendValue {
  text-align: right;
}

.lineChartWrapper {
  display: grid;
  gap: 0.45rem;
}

.lineChartHoverValue {
  margin: 0;
  font-size: 0.82rem;
  color: #334155;
  font-weight: 600;
}

.lineChartSvg {
  width: 100%;
  max-width: 100%;
  height: auto;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  background: linear-gradient(180deg, #f9fbff 0%, #ffffff 85%);
}

.lineChartAxis {
  stroke: #cbd5e1;
  stroke-width: 1.25;
}

.lineChartGridline {
  stroke: #e5e7eb;
  stroke-width: 1;
  stroke-dasharray: 2 3;
}

.lineChartTickLabel {
  fill: #6b7280;
  font-size: 10px;
  text-anchor: end;
}

.lineChartPath {
  fill: none;
  stroke: #2563eb;
  stroke-width: 2.25;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lineChartPoint {
  fill: #1d4ed8;
  transition: transform 120ms ease;
}

.lineChartPointActive {
  fill: #0b4cc2;
}

.lineChartDateLabel {
  fill: #4b5563;
  font-size: 9px;
  text-anchor: middle;
}

.lineChartFootnote {
  margin: 0;
  font-size: 0.78rem;
  color: #6b7280;
}

.usageEmpty {
  margin: 0;
  color: #6b7280;
  font-size: 0.85rem;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #d3d3d3;
  padding: 0.5rem;
  text-align: left;
  vertical-align: top;
}

.table th {
  background-color: #f4f6f8;
}

.continueRow {
  background-color: #f9fbff;
}

.outcomeRow {
  background-color: #fffdf5;
}

.qaCell {
  min-width: 220px;
}

.qaActionRow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.qaAssessmentSpent,
.qaAssessmentQuick,
.qaAssessmentPartial {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.2rem 0.55rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.qaAssessmentSpent {
  background-color: #e4f3e8;
  color: #1f5d2f;
}

.qaAssessmentQuick {
  background-color: #f4e8d8;
  color: #7a4d12;
}

.qaAssessmentPartial {
  background-color: #e6eefc;
  color: #1e429f;
}

.qaModalContent {
  display: grid;
  gap: 1rem;
  min-width: min(42rem, 100%);
}

.qaModalMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
  font-size: 0.95rem;
}

.qaList {
  display: grid;
  gap: 0.75rem;
}

.qaCard {
  border: 1px solid #d3d3d3;
  border-radius: 0.5rem;
  padding: 0.875rem;
  background-color: #f9fbff;
}

.qaCardHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.qaCardHeader h3 {
  margin: 0;
  font-size: 1rem;
}

.qaCardHeader span {
  color: #5c6570;
  font-size: 0.9rem;
}

.qaQuestion {
  margin-top: 0;
  font-weight: 600;
}

.qaCard p {
  margin-bottom: 0;
}

.filterInfo {
  margin: 0.5rem 0 0.75rem;
  color: #5c6570;
  font-size: 0.9rem;
}

.paginationSummary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.paginationControls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.paginationLabel {
  font-size: 0.86rem;
  color: #374151;
}

.emptyMessage {
  text-align: center;
  padding: 2rem 0.5rem !important;
  color: #5c6570;
}
